export const languages = {
  ro: {
    mainMenu: {
      intrareNoua: 'INTRARE NOUĂ',
      intrari: 'INTRARI',
      devize: 'DEVIZE',
      clienti: 'CLIENTI',
      masini: 'MASINI',
      programari: 'PROGRAMARI',
      links: 'LINKS',
    },
    days: [
      'Luni',
      'Marti',
      'Miercuri',
      'Joi',
      'Vineri',
      'Sâmbata',
      'Duminica'
    ],
    daysShort: [
      'Lu',
      'Ma',
      'Mi',
      'Jo',
      'Vi',
      'Sâ',
      'Du'
    ],
    months: [
      'ianuarie',
      'februarie',
      'martie',
      'aprilie',
      'mai',
      'iunie',
      'iulie',
      'august',
      'septembrie',
      'octombrie',
      'noiembrie',
      'decembrie'
    ],
    intrareNoua: 'Intrare nouă',
    clienti: 'Clienți',
    masini: 'Mașini',
    programareNoua: 'Programare nouă',
    programareNouaStepTitle: 'Programare nouă',
    programari: 'Programări',
    date: 'Data',
    time: 'Ora',
    saveBtn: 'Salvează',
    quitBtn: 'Renunță',
    autoDetails: 'DETALII AUTO',
    clientDetails: 'DETALII AUTO',
    repairsDetails: 'DETALII REPARAȚII',
    settings: {
      dateService: 'Date Service',
      pageTitle: 'SETĂRI',
      tarife: 'tarife',
      rarAutopass: 'RAR Autopass'
    },
    general: 'general',
    language: 'Limbă',
    search: 'cauta',
    car: 'car', // this is for icon
    nrCrt: 'Nr.',
    nrAuto: 'NUMĂR',
    marca: 'Marcă',
    model: 'Model',
    culoare: 'culoare',
    telefon: 'telefon',
    observatii: 'observații',
    numar: 'Număr',
    sasiu: 'Șasiu',
    km: 'Km',
    carburant: 'Carburant',
    cilindree: 'Cilindree',
    putere: 'Putere',
    an: 'An',
    itp: 'ITP',
    asigurare: 'Asigurare',
    detaliiAuto: 'DETALII AUTO',
    detaliiClient: 'DETALII CLIENT',
    detaliiReparatii: 'DETALII REPARAȚII',
    client: {
      nume: 'Nume',
      proprietar: 'Proprietar',
      telefon: 'Telefon',
      email: 'Email',
      numeFirma: 'Nume firmă',
      cui: 'C.U.I.',
      adresaFirma: 'Adresă',
      city: 'Oraș',
      state: 'Județ',
    },
    cerinteClient: 'Cerințe client',
    defectiuni: 'Defecțiuni',
    operatiuni: 'Operațiuni',
    pieseClient: 'Piese client',
    comanda: 'Comandă',
    deviz: 'Deviz',
    deviz_oferta: 'DEVIZ OFERTĂ',
    firma: 'firma',
    reset: 'Resetează',
    invoice: 'Factură',
    print: 'Print',
    delete: 'Șterge',
    auth_error: {
      invalid_credentials: 'Utilizator sau parolă incorectă.',
      account_blocked: 'Contul este blocat sau expirat. Vă rugăm să contactați administratorul.',
      too_many_attempts: 'Prea multe încercări de autentificare. Încercați din nou mai târziu.',
      unknown: 'A apărut o eroare neașteptată. Vă rugăm să încercați din nou.'
    },
  },
  se: {
    mainMenu: {
      intrareNoua: 'Ny inkommande',
      intrari: 'Inkommande',
      clienti: 'Kunder',
      masini: 'Fordon',
      programari: 'Bokningar',
      links: 'Länkar',
    },
    daysShort: [
      'mån',
      'tis',
      'ons',
      'tors',
      'fre',
      'lör',
      'sön'
    ],
    days: [
      'måndag',
      'tisdag',
      'onsdag',
      'torsdag',
      'fredag',
      'lördag',
      'söndag'
    ],
    months: [
      'januari',
      'februari',
      'mars',
      'april',
      'maj',
      'juni',
      'juli',
      'augusti',
      'september',
      'oktober',
      'november',
      'december'
    ],
    intrareNoua: 'Ny inkommande',
    programareNoua: 'Ny bokning',
    programareNouaStepTitle: 'BOKNING',
    programari: 'Bokningar',
    date: 'Datum',
    time: 'Tid',
    saveBtn: 'Spara',
    quitBtn: 'Stäng',
    autoDetails: 'FORDONSDETALJER',
    clientDetails: 'KUNDDETALJER',
    repairsDetails: 'REPARATIONSDETALJER',
    settings: {
      dateService: 'Företagsuppgifter',
      pageTitle: 'inställningar',
      tarife: 'tariff',
      rarAutopass: 'RAR Autopass'
    },
    general: 'Allmänna inställningar',
    language: 'språk',
    search: 'sök',
    car: 'car', // this is for icon
    nrCrt: 'Nu.',
    nrAuto: 'Registreringsnummer',
    marca: 'Märke',
    model: 'Modell',
    culoare: 'Färg',
    telefon: 'Telefon',
    observatii: 'Anmärkningar',
    numar: 'Nummer',
    sasiu: 'Chassinummer',
    km: 'Mätarställning',
    carburant: 'Bränsle',
    cilindree: 'Motorvolym',
    putere: 'Effekt',
    an: 'Årsmodell',
    itp: 'Besiktning',
    asigurare: 'Försäkring',
    detaliiAuto: 'FORDONSDETALJER',
    detaliiClient: 'KUNDDETALJER',
    detaliiReparatii: 'Reparationsdetaljer',
    client: {
      nume: 'Namn',
      proprietar: 'Ägare',
      telefon: 'Telefon',
      email: 'E-post',
      numeFirma: 'Företagsnamn',
      cui: 'Organisationsnummer',
      adresaFirma: 'Företagsadress'
    },
    cerinteClient: 'Kundkrav',
    defectiuni: 'Fel',
    pieseClient: 'Kunddelar',
    comanda: 'Arbetsorder',
    deviz: 'Kostnadsförslag',
    auth_error: {
      invalid_credentials: 'Felaktigt användarnamn eller lösenord.',
      account_blocked: 'Kontot är blockerat eller har gått ut. Kontakta administratören.',
      too_many_attempts: 'För många inloggningsförsök. Försök igen senare.',
      unknown: 'Ett oväntat fel inträffade. Försök igen senare.'
    }
  }
}